var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChewronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9196_61366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21582 12.6594C8.09675 12.7802 7.90325 12.7802 7.78418 12.6594L0.0888831 4.85186C-0.0296281 4.73163 -0.029628 4.53711 0.0888832 4.41687L1.14967 3.34061C1.26875 3.2198 1.46224 3.2198 1.58132 3.34061L7.85612 9.70692C7.9355 9.78746 8.0645 9.78746 8.14388 9.70692L14.4187 3.34061C14.5378 3.2198 14.7312 3.2198 14.8503 3.34061L15.9111 4.41687C16.0296 4.53711 16.0296 4.73163 15.9111 4.85187L8.21582 12.6594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9196_61366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChewronDown);
export default __webpack_public_path__ + "static/media/iconChewronDown.ee48265745c0c058d613392d0d319ee0.svg";
export { ForwardRef as ReactComponent };